'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _call2 = require('./_internal/_call');

var _call3 = _interopRequireDefault(_call2);

var _concat2 = require('./_internal/_concat');

var _concat3 = _interopRequireDefault(_concat2);

var _len4 = require('./_internal/_len');

var _len5 = _interopRequireDefault(_len4);

var _lt2 = require('./_internal/_lt');

var _lt3 = _interopRequireDefault(_lt2);

var _or2 = require('./_internal/_or');

var _or3 = _interopRequireDefault(_or2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var define = function define(fn, len) {
    var length = (0, _or3.default)(len, (0, _len5.default)(fn));
    var internal = function internal() {
        for (var _len2 = arguments.length, args = Array(_len2), _key = 0; _key < _len2; _key++) {
            args[_key] = arguments[_key];
        }

        return (0, _lt3.default)((0, _len5.default)(args), length) ? function () {
            for (var _len3 = arguments.length, ops = Array(_len3), _key2 = 0; _key2 < _len3; _key2++) {
                ops[_key2] = arguments[_key2];
            }

            return (0, _call3.default)(internal, (0, _concat3.default)(args, ops));
        } : (0, _call3.default)(fn, args);
    };

    return internal;
}; /**
    * Take a function with a known signature and allow arguments to be
    * passed until it executes
    *
    * @module define
    * @func
    * @since 1.0.0
    * @update
    * @param {function} fn
    * @return {function|*}
    * @example
    *
    *     const foo = (a, b, c) => a + b + c;
    *     const bar = define(foo);
    *     bar(1); // (b, c) => 1 + b + c
    *     bar(1)(2); // c => 1 + 2 + c
    *     bar(1)(2)(3); // 6
    */

exports.default = define;